import { render, staticRenderFns } from "./TipoInvestimento.vue?vue&type=template&id=88767050&lang=html&"
import script from "./TipoInvestimento.vue?vue&type=script&lang=js&"
export * from "./TipoInvestimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/tipo-investimento/TipoInvestimento.vue
// module id = 1529
// module chunks = 28